/**
 * Returns pathname for reliable comparisons (excluding query params).
 * @param urlOrPath URL string
 * @returns pathname
 */
export const getPathname = (urlOrPath: string): string => {
	const url = new URL(urlOrPath, window.location.origin);
	return url.pathname;
};

/**
 * Compares two URLs by their pathnames
 * @param a URL string
 * @param b URL string
 * @returns true if the pathnames are the same, false otherwise
 */
export const isSamePathname = (a: string, b: string): boolean => {
	try {
		return getPathname(a) === getPathname(b);
	} catch {
		return false;
	}
};
